module.exports = __webpack_public_path__ + "static/logo-0015539919569576a96ccbcf608c0d93.png";